<template>
  <form id="sendEmailForm" class="login-form" @submit.prevent="sendEmail" v-if="formVisible">
    <TextInput name="userName" placeholder="Benutzername" min="1" />
    <TextInput name="emailAddress" placeholder="E-Mail-Adresse" min="1" />
    <PrimaryButton :full-width="true" text="E-Mail senden" :disabled="!formValid" />
  </form>
</template>

<script>
import PrimaryButton from "@/components/elements/PrimaryButton.vue";
import TextInput from "@/components/elements/TextInput.vue";
import {nextTick} from "vue";

export default {
  data() {
    return {
      formValid: false,
      formVisible: true,
    };
  },
  components: {
    PrimaryButton,
    TextInput,
  },
  methods: {
    async sendEmail() {
      const data = this.getFormData('sendEmailForm');
      data.action = 'sendResetEmail';

      const res = await this.apiRequest("PATCH", "/account/passwordReset", data, false);
      if(!res.success) {
        this.showAPIError(res, "Fehler beim Senden der E-Mail.");
        return;
      }
      this.showNotice({
        type: 'success',
        content: 'E-Mail zum Zurücksetzen des Passworts erfolgreich verschickt!',
      });
      this.formValid = false;
      this.formVisible = false;
      await nextTick();
      this.formVisible = true;
    },
  }
}
</script>